
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorInsertPointIcon as ObiCursorInsertPointIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-insert-point-icon.js';
 
 
 

 
 export const ObiCursorInsertPointIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-insert-point-icon',
   elementClass: ObiCursorInsertPointIconElement,
   events: {
     
   }
  });
 
 